import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const userSettingsApi = createApi({
  reducerPath: "users",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    newUser: builder.mutation({
      query: (body) => ({
        url: `v1/customers/users/`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useNewUserMutation } = userSettingsApi;
